/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityResponse } from '../../models/activity-response';

export interface GetRandomActivitiesForProfileWithExclude$Params {
  id: number;
  count: number;
  exclude: number;
}

export function getRandomActivitiesForProfileWithExclude(http: HttpClient, rootUrl: string, params: GetRandomActivitiesForProfileWithExclude$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
  const rb = new RequestBuilder(rootUrl, getRandomActivitiesForProfileWithExclude.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('count', params.count, {});
    rb.path('exclude', params.exclude, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityResponse>>;
    })
  );
}

getRandomActivitiesForProfileWithExclude.PATH = '/rest/profile/{id}/random-activities/{count}/{exclude}';
